import { render, staticRenderFns } from "./ModalConsultarSolicitacaoAlteracaoValor.vue?vue&type=template&id=1376c3cb"
import script from "./ModalConsultarSolicitacaoAlteracaoValor.vue?vue&type=script&lang=js"
export * from "./ModalConsultarSolicitacaoAlteracaoValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports